import { render, staticRenderFns } from "./RegistrationNew.vue?vue&type=template&id=4189f82f&scoped=true&"
import script from "./RegistrationNew.vue?vue&type=script&lang=js&"
export * from "./RegistrationNew.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationNew.vue?vue&type=style&index=0&id=4189f82f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4189f82f",
  null
  
)

export default component.exports